import { render } from "./colorOption.vue?vue&type=template&id=ad9e67b6&scoped=true"
import script from "./colorOption.vue?vue&type=script&lang=js"
export * from "./colorOption.vue?vue&type=script&lang=js"

import "./colorOption.vue?vue&type=style&index=0&id=ad9e67b6&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9e67b6"]])

export default __exports__